import React, { useEffect } from 'react';
import baseAssetTags from '../tracking/assetTagRegistry.json';
import extraAssetTags from '../tracking/assetTagRegistryExtras.json';
import { supabase } from '../auth/supabase';

const assetTags = [...baseAssetTags, ...extraAssetTags];

function normalizeId(value) {
  return decodeURIComponent(String(value || '')).trim().toUpperCase();
}

function digits(value) {
  return String(value || '').replace(/\D+/g, '');
}

export default function AssetTagPublic({ assetId }) {
  const id = normalizeId(assetId);
  const asset = assetTags.find(item => normalizeId(item.id) === id);

  useEffect(() => {
    let cancelled = false;
    if (!asset) return undefined;

    supabase.auth.getSession()
      .then(({ data }) => {
        if (cancelled || !data?.session) return;
        window.location.replace(`/my-gear?asset=${encodeURIComponent(asset.id)}&source=tag`);
      })
      .catch(() => {});

    return () => { cancelled = true; };
  }, [asset, id]);

  const shell = {
    minHeight: '100vh',
    background: '#101311',
    color: '#f7f7f2',
    padding: '28px 16px 48px',
    fontFamily: 'Arial, Helvetica, sans-serif',
  };
  const card = {
    maxWidth: 560,
    margin: '0 auto',
    background: '#1a1f1b',
    border: '1px solid rgba(255,255,255,.12)',
    borderRadius: 24,
    padding: 28,
    boxShadow: '0 18px 60px rgba(0,0,0,.28)',
  };
  const button = {
    display: 'block',
    width: '100%',
    boxSizing: 'border-box',
    textAlign: 'center',
    textDecoration: 'none',
    borderRadius: 14,
    padding: '15px 18px',
    fontWeight: 800,
    fontSize: 17,
    marginTop: 12,
  };

  if (!asset) {
    return (
      <main style={shell}>
        <section style={card}>
          <div style={{ fontSize: 13, letterSpacing: 1.8, color: '#d9a441', fontWeight: 800 }}>LINE MEDIC · ASSET RECOVERY</div>
          <h1 style={{ margin: '10px 0 8px', fontSize: 34 }}>Asset tag not registered</h1>
          <p style={{ color: '#bbc2bc', lineHeight: 1.6 }}>
            This QR/NFC tag does not match a registered Line Medic asset. If you found equipment carrying this tag, use the organization contact information printed on the physical equipment or return it to the agency identified on the gear.
          </p>
        </section>
      </main>
    );
  }

  const phoneHref = digits(asset.phone) ? `tel:+1${digits(asset.phone).slice(-10)}` : '';
  const emailHref = asset.email ? `mailto:${asset.email}?subject=${encodeURIComponent(`Found ${asset.id}`)}` : '';

  return (
    <main style={shell}>
      <section style={card}>
        <div style={{ fontSize: 13, letterSpacing: 1.8, color: '#d9a441', fontWeight: 800 }}>LINE MEDIC · REGISTERED ASSET</div>
        <h1 style={{ margin: '12px 0 4px', fontSize: 38, lineHeight: 1.04 }}>You found Line Medic program gear</h1>
        <div style={{ marginTop: 22, padding: 20, borderRadius: 18, background: '#111512', border: '1px solid rgba(217,164,65,.3)' }}>
          <div style={{ color: '#9fa99f', fontSize: 12, letterSpacing: 1.3, fontWeight: 800 }}>ASSET</div>
          <div style={{ fontSize: 28, fontWeight: 900, marginTop: 5 }}>{asset.name}</div>
          <div style={{ color: '#d9a441', fontWeight: 800, marginTop: 5 }}>{asset.id}</div>
          <div style={{ color: '#aeb7ae', marginTop: 6 }}>{asset.category}</div>
        </div>

        <h2 style={{ margin: '26px 0 4px', fontSize: 21 }}>Please contact</h2>
        <div style={{ color: '#d7ddd7', fontSize: 18, fontWeight: 700 }}>{asset.contactName}</div>

        {phoneHref && (
          <a href={phoneHref} style={{ ...button, background: '#d97824', color: '#111' }}>
            Call {asset.phone}
          </a>
        )}
        {emailHref && (
          <a href={emailHref} style={{ ...button, background: '#f4f4ee', color: '#151815' }}>
            Email {asset.email}
          </a>
        )}

        <p style={{ color: '#aeb7ae', lineHeight: 1.55, marginTop: 24 }}>
          The QR code and NFC tag on this gear both identify the same registered asset. The organization-specific recovery contact above is configured by the program that owns the equipment. No private member, medication, inventory, or deployment information is shown on this public page.
        </p>

        <a href={`/my-gear?asset=${encodeURIComponent(asset.id)}&source=tag`} style={{ ...button, background: 'transparent', color: '#f2f3ef', border: '1px solid rgba(255,255,255,.18)' }}>
          Program member? Open Line Medic
        </a>
      </section>
    </main>
  );
}
